import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'
import { Nav as ReactStrapNav } from 'reactstrap'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .review-pagination {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;

    @media ${queries.less.sm} {
      flex-direction: column;
      gap: 1.5rem;
      margin-bottom: 4.5rem;
    }
  }
`

export const Nav = styled(ReactStrapNav)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2em;
  align-items: end;
  border-bottom: 1px solid rgba(196, 196, 196, 0.2) !important;
  padding: 0;
  box-shadow: none !important;
  overflow-x: auto;
  overflow-y: hidden;

  @media ${queries.less.sm} {
    width: 100%;
    gap: 0;
    justify-content: start;
    align-items: start !important;
  }

  > li {
    gap: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: auto;
    height: 100%;
    font-size: 18px;
    padding: 17px 16px;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    .nav-link {
      color: #d2d2ff !important;
    }

    @media ${queries.less.sm} {
      padding: 1em 1em 0.5em 1em;
    }

    .count {
      display: flex;
      width: 24px;
      height: 24px;
      padding: 4px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 99px;
      background: #ff4c5129;
      position: relative;

      span {
        position: absolute;
        margin: 0 auto;
        transform: translateY(-50%);
        top: 50%;
        color: #ff4c51;
        text-align: right;
        leading-trim: both;
        text-edge: cap;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;
      }
    }
  }

  > li[data-active='true'] {
    color: #556ee6 !important;
    border-bottom: 3px solid #556ee6;
    cursor: default;
  }
`

export const Title = styled.h3`
  color: #2c2c2c;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`

export const CustomPagination = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;

  @media ${queries.less.sm} {
    width: 100%;
    justify-content: center;
  }

  button {
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    border: none;
    background-color: #ededed;
    border-radius: 999999px;
    aspect-ratio: 1/1;

    &:hover {
      background-color: #b3b1b1;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
    }

    &[data-active='true'] {
      background-color: #6f64f8;
      color: #fff;
    }

    &:disabled {
      background-color: #f7fafc;
      cursor: not-allowed;
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ededed;
    border-radius: 999999px;
  }
`

export const NoContentWrapper = styled.div`
  display: flex;
  height: 400px;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;

  svg {
    width: 141.956px;
    height: 117.339px;
    flex-shrink: 0;
  }

  span {
    color: #767676;
    width: 535px;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`
